import React from 'react';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { NotificationInterface } from '../../../../../Models/Notification';
import GGButton from '../../../GGButton/GGButton';

interface NotificationDropdownProps {
  notifications: NotificationInterface[];
  unreadCount: number;
  onNotificationClick: () => void;
}

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  notifications,
  unreadCount,
  onNotificationClick
}) => {
  return (
    <>
      {notifications.map((notification, index) => (
        <div className='message-container' key={index} onClick={onNotificationClick}>
          <div className="left">
            <NotificationsOutlinedIcon />
          </div>
          <div className="middle">
            <h3>{notification.title.slice(0, 20) + " ..."}</h3>
            <p>{notification.message.slice(0, 25) + " ..."}</p>
          </div>
        </div>
      ))}
      <GGButton 
        className='see-all-notifs-btn' 
        onClick={onNotificationClick} 
        variant='outlined'
      >
        See All +{unreadCount}
      </GGButton>
    </>
  );
};

export default NotificationDropdown;
